import { useEffect, useState } from 'react';

interface Props {
  onConfirm: (count: number, offsetX: number, offsetZ: number) => void;
  onCancel: () => void;
}

export function DuplicateOffsetPopover({ onConfirm, onCancel }: Props) {
  const [count, setCount] = useState(3);
  const [offsetX, setOffsetX] = useState(1.5);
  const [offsetZ, setOffsetZ] = useState(0);

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onCancel]);

  // Clamped once and reused for both the button label and the actual
  // duplicate count, so what the button says matches what it does.
  const safeCount = Math.max(1, Math.min(20, Math.round(count) || 1));

  const submit = () => {
    onConfirm(safeCount, offsetX, offsetZ);
  };

  return (
    <div className="editor-popover ui-panel">
      <header className="editor-section-header">
        <div>
          <span className="editor-section-eyebrow">Duplicate pattern</span>
          <h3>Linear copies</h3>
        </div>
        <button type="button" className="editor-chip" onClick={onCancel}>✕</button>
      </header>
      <div className="editor-field-grid">
        <label className="editor-field">
          <span>Count</span>
          <input
            type="number"
            min={1}
            max={20}
            value={count}
            onChange={(event) => setCount(Number(event.target.value))}
          />
        </label>
        <label className="editor-field">
          <span>Offset X</span>
          <input
            type="number"
            step={0.1}
            value={offsetX}
            onChange={(event) => setOffsetX(Number(event.target.value))}
          />
        </label>
        <label className="editor-field">
          <span>Offset Z</span>
          <input
            type="number"
            step={0.1}
            value={offsetZ}
            onChange={(event) => setOffsetZ(Number(event.target.value))}
          />
        </label>
      </div>
      <div className="editor-toolbar editor-toolbar-secondary">
        <button type="button" className="editor-action-btn" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="editor-action-btn is-primary" onClick={submit}>
          Duplicate {safeCount}
        </button>
      </div>
    </div>
  );
}
